"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgNoAccount = function SvgNoAccount(_ref) {
  var fill = _ref.fill,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["fill", "theme"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "36",
    height: "32",
    viewBox: "0 0 36 32",
    fill: "none"
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.0058 8.19795L23.1878 9.02245L23.1698 12.151L20.9883 12.3885L21.7618 18.206H24.0058V27.8695C24.0058 28.8015 23.2503 29.5575 22.3183 29.5575H11.6213C10.0638 29.5575 8.80176 28.295 8.80176 26.7375V3.87695C8.80176 2.94495 9.55726 2.18945 10.4893 2.18945H22.3183C23.2503 2.18945 24.0058 2.94495 24.0058 3.87695V8.19795Z",
      fill: fill || theme.colors.primary.main,
      fillOpacity: "0.2"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.1574 21.8574H1.9834C1.7074 21.8574 1.4834 21.6339 1.4834 21.3574C1.4834 21.0809 1.7074 20.8574 1.9834 20.8574H4.1574C4.4339 20.8574 4.6574 21.0809 4.6574 21.3574C4.6574 21.6339 4.4339 21.8574 4.1574 21.8574Z",
      fill: fill || theme.colors.primary.main,
      fillOpacity: "0.5"
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "19",
      y: "30",
      width: "4",
      height: "2",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.2227 30.9941H22.3967V31.994H19.2227V30.9941Z",
        fill: "white"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#mask0)",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.8967 31.9941H19.7227C19.4467 31.9941 19.2227 31.7706 19.2227 31.4941C19.2227 31.2176 19.4467 30.9941 19.7227 30.9941H21.8967C22.1732 30.9941 22.3967 31.2176 22.3967 31.4941C22.3967 31.7706 22.1732 31.9941 21.8967 31.9941Z",
        fill: fill || theme.colors.primary.main,
        fillOpacity: "0.3"
      })
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.31315 23.5469H1.13965C0.863648 23.5469 0.639648 23.3234 0.639648 23.0469C0.639648 22.7704 0.863648 22.5469 1.13965 22.5469H3.31315C3.58965 22.5469 3.81315 22.7704 3.81315 23.0469C3.81315 23.3234 3.58965 23.5469 3.31315 23.5469Z",
      fill: fill || theme.colors.primary.main,
      fillOpacity: "0.5"
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "mask1",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "30",
      y: "1",
      width: "5",
      height: "5",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.5469 1.60742H34.2047V5.26492H30.5469V1.60742Z",
        fill: "white"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#mask1)",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M33.7049 2.93642H32.8759V2.10742C32.8759 1.83092 32.6524 1.60742 32.3759 1.60742C32.0994 1.60742 31.8759 1.83092 31.8759 2.10742V2.93642H31.0469C30.7704 2.93642 30.5469 3.15992 30.5469 3.43642C30.5469 3.71292 30.7704 3.93642 31.0469 3.93642H31.8759V4.76492C31.8759 5.04142 32.0994 5.26492 32.3759 5.26492C32.6524 5.26492 32.8759 5.04142 32.8759 4.76492V3.93642H33.7049C33.9814 3.93642 34.2049 3.71292 34.2049 3.43642C34.2049 3.15992 33.9814 2.93642 33.7049 2.93642Z",
        fill: fill || theme.colors.primary.main,
        fillOpacity: "0.5"
      })
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.6952 19.708C25.4187 19.708 25.1952 19.9315 25.1952 20.208V26.18C25.1952 26.835 24.6627 27.3675 24.0077 27.3675H12.1787C11.5237 27.3675 10.9912 26.835 10.9912 26.18V2.1875C10.9912 1.5325 11.5237 1 12.1787 1H24.0077C24.6627 1 25.1952 1.5325 25.1952 2.1875V6.645C25.1952 6.9215 25.4187 7.145 25.6952 7.145C25.9717 7.145 26.1952 6.9215 26.1952 6.645V2.1875C26.1952 0.9815 25.2137 0 24.0077 0H12.1787C10.9727 0 9.99121 0.9815 9.99121 2.1875V26.18C9.99121 27.386 10.9727 28.3675 12.1787 28.3675H24.0077C25.2137 28.3675 26.1952 27.386 26.1952 26.18V20.208C26.1952 19.9315 25.9717 19.708 25.6952 19.708Z",
      fill: fill || theme.colors.primary.main
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.3125 25.5869C15.3125 25.8634 15.536 26.0869 15.8125 26.0869H20.374C20.6505 26.0869 20.874 25.8634 20.874 25.5869C20.874 25.3104 20.6505 25.0869 20.374 25.0869H15.8125C15.536 25.0869 15.3125 25.3104 15.3125 25.5869Z",
      fill: fill || theme.colors.primary.main
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.4068 17.1425C27.4043 17.163 27.4028 17.183 27.4028 17.2035C27.4028 17.4805 27.1773 17.706 26.9003 17.706H22.4908C22.2138 17.706 21.9883 17.4805 21.9883 17.2035C21.9883 17.183 21.9868 17.163 21.9843 17.1425L21.4888 13.1075C21.5023 12.842 21.7223 12.6305 21.9908 12.6305H27.4003C27.6688 12.6305 27.8893 12.842 27.9023 13.1075L27.4068 17.1425ZM23.5443 10.2965C23.5443 9.66151 24.0608 9.14551 24.6953 9.14551C25.3303 9.14551 25.8463 9.66151 25.8463 10.2965V11.6305H23.5443V10.2965ZM27.4003 11.6305H26.8463V10.2965C26.8463 9.11051 25.8813 8.14551 24.6953 8.14551C23.5093 8.14551 22.5443 9.11051 22.5443 10.2965V11.6305H21.9908C21.1623 11.6305 20.4883 12.304 20.4883 13.1325C20.4883 13.153 20.4898 13.1735 20.4923 13.194L20.9888 17.237C21.0063 18.05 21.6733 18.706 22.4908 18.706H26.9003C27.7178 18.706 28.3848 18.05 28.4023 17.237L28.8988 13.194C28.9013 13.1735 28.9028 13.153 28.9028 13.1325C28.9028 12.304 28.2293 11.6305 27.4003 11.6305Z",
      fill: fill || theme.colors.primary.main
    })]
  }));
};

var _default = SvgNoAccount;
exports["default"] = _default;